export default __webpack_public_path__ + "static/media/trash.7cfd0831.svg";